export class Department {
    $id: string;
    DepartmentID: string;
    Name: string;
    CreatedDate?: any;
    CreatedByUserId?: any;
    IsUsingDms: boolean;

    public constructor(init?: Partial<Department>) {
        Object.assign(this, init);
    }
}
